// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { attributesStyles } from "@awc/Overrides/Widgets/ProductDetails/ProductDetailsAttributes";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color } from "@awc/XDL/Utilities";
import { css } from "styled-components";

attributesStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        position: relative;
        border: 2px solid ${color("primary")};
        border-radius: 4px;

        & > div {
            &:first-child {
                .value {
                    border-radius: 0 4px 0 0;
                }
            }
            &:last-child {
                .value {
                    border-radius: 0 0 4px 0;
                }
            }
        }

        & > div:nth-of-type(odd) {
            .value {
                background: ${color("common.ui15")};
            }
        }
    `,
};

attributesStyles.attributeTypeLabelText = {
    size: fontConfig.fontSize.small,
    lineHeight: fontConfig.lineHeight.singleLineSmall,
    color: "common.white",
    css: css`
        background-color: ${color("primary")};
        padding: 8px 12px;
        width: 100%;
        max-width: 155px;
        white-space: pre-wrap;
    `,
};

attributesStyles.attributeTypeValuesText = {
    size: fontConfig.fontSize.small,
    lineHeight: fontConfig.lineHeight.singleLineSmall,
    css: css`
        padding: 8px 12px;
        width: 100%;
    `,
};

attributesStyles.attrTextLabel = {
    variant: "h2",
};

attributesStyles.rowWrapper = {
    css: css`
        display: flex;
    `,
};

attributesStyles.downloadButton = {
    sizeVariant: "small",
    css: css`
        margin-top: 18px;
    `,
};
